export default __webpack_public_path__ + "static/media/icon.78bf5b91.png";